import { Divider, Menu, MenuItem, Typography } from "@mui/material"
import React from "react"

interface Props {
  open: boolean
  menuElement: null | HTMLElement
  onClose: () => void
  onTemperatureDifferentialReportSelected: () => void
  onSelectedSensorsReportSelected: () => void
  onExportToExcelSelected: () => void
  selectedSensorsCount: number,
}

const ReportMenu = (props: Props) => {
  return (
    <Menu
      id="report-menu"
      anchorEl={props.menuElement}
      open={props.open}
      onClose={() => {
        props.onClose()
      }}
    >
      <Typography variant="caption" color="black" sx={{
        margin: "14px"
      }}>
        PDF Reports
      </Typography>
      <MenuItem disabled={props.selectedSensorsCount < 2} onClick={() => {
        props.onClose()
        props.onTemperatureDifferentialReportSelected()
      }}>
        <Typography variant="body1">
          Temperature Differential
        </Typography>
      </MenuItem>
      <MenuItem disabled={props.selectedSensorsCount == 0} onClick={() => {
        props.onClose()
        props.onSelectedSensorsReportSelected()
      }}>
        <Typography variant="body1">
          Selected Sensors
        </Typography>
      </MenuItem>
      <Divider />
      <Typography variant="caption" color="black" sx={{
        margin: "14px"
      }}>
        Export...
      </Typography>
      <MenuItem disabled={props.selectedSensorsCount == 0} onClick={() => {
        props.onClose()
        props.onExportToExcelSelected()
      }}>
        <Typography variant="body1">
          To Excel
        </Typography>
      </MenuItem>
    </Menu>
  )
}

export default ReportMenu